function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 122.88 102.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M65.61 20.91v72.74h35.63c.38 0 .68.31.68.69v7.7c0 .38-.31.69-.68.69h-78.4c-.38 0-.69-.31-.69-.69v-7.7c0-.38.31-.69.69-.69h35.63V20.94a10.81 10.81 0 0 1-6.64-6.63H29.3v3.43c0 .38-.31.68-.68.68h-5.78a.69.69 0 0 1-.69-.68v-3.43h-5.73c-.44 0-.8-.31-.8-.68V7.84c0-.38.36-.69.8-.69h35.43C53.33 2.99 57.31 0 61.99 0s8.66 2.99 10.14 7.16h35.53c.44 0 .8.31.8.69v5.78c0 .38-.36.68-.8.68h-6.46v3.43c0 .38-.31.68-.68.68h-5.78a.69.69 0 0 1-.69-.68v-3.43H72.16c-1.07 3.07-3.49 5.5-6.55 6.6m34.05 1.39 22.91 40.48c.2.35.29.73.28 1.1h.02v.15c0 9.64-11.35 17.46-25.35 17.46-13.85 0-25.1-7.65-25.34-17.15a2.16 2.16 0 0 1 .31-1.71L95.92 22.2a2.13 2.13 0 0 1 2.91-.78c.37.23.65.53.83.88m.09 8.81v30.6h17.32zM95.67 61.7V31.16L77.96 61.7zM27.54 22.3l22.91 40.48c.2.35.29.73.28 1.1h.02v.15c0 9.64-11.35 17.46-25.35 17.46C11.55 81.49.3 73.84.06 64.34c-.04-.15-.06-.32-.06-.5 0-.44.14-.86.37-1.2L23.8 22.21a2.128 2.128 0 0 1 3.74.09m.09 8.81v30.6h17.32zM23.54 61.7V31.16L5.84 61.7zM61.99 6.07a4.69 4.69 0 1 1 0 9.38 4.69 4.69 0 0 1 0-9.38",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.15b219a0c03aa88e7070fcbbe24d0055.svg";
export { ForwardRef as ReactComponent };